<template>
<div class="modal-mask">
  <div class="modal-wrapper">
    <div class="modal-container col-sm-12 col-md-11">
      <div class="modal-body">
        <button class="modal-default-button" @click="closeModal">
          <img src="../assets/images/portfolio/exit.png">
        </button>
        <slot/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  export default {
    name: 'modal',
    methods: {
      closeModal () {
        this.$emit('close')
        // this.$router.push({ name: 'Services' })
      }
    }
  }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .modal-mask {
    position: fixed;
    z-index: 999999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: table;
    transition: opacity .3s ease;
    background-color: rgba(0,0,0,0);
  }

  .modal-wrapper {
    //display: table-cell;
    vertical-align: middle;
    width: 100%;
    height: 100vh;
  }

  .modal-container {
    height: 100%;
    margin: 0px 0px auto auto;
    background-color: #EFF7FB;
    border-radius: 2px;
    box-shadow: 0 2px 20px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    background-color: #EFF7FB;
    background-repeat:no-repeat;
    padding: 0;
  }

  /*img {
    width: 30px;
    height: 30px;
  }*/

  .modal-default-button {
    position: fixed;
    background-color: transparent !important;
    border: none;
    right: 1rem;
    top: 1rem;
    cursor: pointer;
    z-index: 99999;
    img {
      width: 30px;
      opacity: 0.7;
    }

    &:hover {
      img {
        opacity: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue